import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addCustomerRes;
export const addCustomerTodo = createAsyncThunk('addCustomer', async (data) => {
    // console.log("data", data)


    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'customer_signup',
            data: {
                "name": data.name,
                "email": data.email,
                "password": data.password,
                "year": data.year.toLocaleDateString("en-IN", { year: "numeric" }),
                "branch": data.branch.toString(),
                "type": data.type,
                "hod": data.type === 'teacher' ? '0' : data.hod.toString(),
                "added_by": localStorage.getItem('vcustomer_code'),
                "vcustomer_code": localStorage.getItem('vcustomer_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id')
            },
            headers: { "Content-Type": "application/json" }
        })
        return addCustomerRes = res.data

    } catch (error) {
        return addCustomerRes = error.response.data
    }
})


export var updateCustomerRes;
export const updateCustomerTodo = createAsyncThunk('updateCustomer', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'customer_profile_updated',
            data: {
                "id": data.id,
                "name": data && data.values && data.values.name,
                "email": data && data.values && data.values.email,
                "year": data && data.values && data.values.year.toLocaleDateString("en-IN", { year: "numeric" }),
                "branch": data && data.values && data.values.branch.toString(),
                'status': data && data.values && data.values.status,
                "type": data.values.type,
                "hod": data.values.hod === 'self' ? '' : data.values.hod,
            },
            headers: { "Content-Type": "application/json" }
        })
        return updateCustomerRes = res.data

    } catch (error) {
        return updateCustomerRes = error.response.data
    }
})


// export var updateCustomerRes;
// export const updateCustomerTodo = createAsyncThunk('updateCustomer', async (data) => {
//     console.log("updatedata", data)
//     try {
//         const res = await axios({
//             method: "post",
//             url: process.env.REACT_APP_API_URL + 'customer_signup',
//             data: {
//                 "id": data.id,
//                 "name": data && data.values && data.values.name,
//                 "email": data && data.values && data.values.email,
//                 "year": data && data.values && data.values.year.toLocaleDateString("en-IN", { year: "numeric" }),
//                 "branch": data && data.values && data.values.branch.toString(),
//                 'status': data && data.values && data.values.status,
//                 "type": data.type,
//                 "hod": data.hod === 'self' ? '' : data.hod.toString(),
//             },
//             headers: { "Content-Type": "application/json" }
//         })
//         return updateCustomerRes = res.data

//     } catch (error) {
//         return updateCustomerRes = error.response.data
//     }
// })
